import { Button } from "@/components/ui/button";
import { Clock3, MapPin, Navigation, Phone } from "lucide-react";

/** A single assigned appointment card on the photographer's field schedule. */
export function PhotographerJobCard({ job, onUpdateStatus }) {
  return (
    <article data-testid={`photographer-job-${job.id}`} className="border border-[#282C34] bg-[#121418] p-5 sm:p-6">
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 text-[11px] font-mono text-[#C8B9A6]"><Clock3 size={14} />{job.scheduled_date} · {job.scheduled_time} · {job.property_timezone}</div>
          <h2 className="text-xl mt-3">{job.address?.street}</h2>
          <p className="text-sm text-[#9A9EA7] mt-1">{job.address?.city}, {job.address?.state} {job.address?.zip}</p>
        </div>
        <span data-testid={`photographer-job-status-${job.id}`} className="h-fit border border-emerald-700 bg-emerald-950/40 px-2 py-1 text-[10px] uppercase font-mono text-emerald-300">{job.status.replace("_", " ")}</span>
      </div>
      <div className="grid md:grid-cols-3 gap-5 mt-6 border-t border-[#282C34] pt-5 text-sm">
        <div>
          <div className="text-[10px] font-mono uppercase text-[#9A9EA7]">Services</div>
          <p className="mt-2">{job.services.join(", ") || "Media appointment"}</p>
          {job.sqft && <p className="text-[#9A9EA7] mt-1">{job.sqft.toLocaleString()} sq ft</p>}
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase text-[#9A9EA7]">On-site contact</div>
          <p className="mt-2">{job.meeting?.contact_name || job.contact?.name || "—"}</p>
          {(job.meeting?.contact_phone || job.contact?.phone) && <a data-testid={`photographer-call-${job.id}`} href={`tel:${job.meeting?.contact_phone || job.contact?.phone}`} className="inline-flex items-center gap-1 mt-1 text-[#E5B869]"><Phone size={13} />Call</a>}
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase text-[#9A9EA7]">Access</div>
          <p className="mt-2 whitespace-pre-wrap">{job.meeting?.access || job.meeting?.notes || "No special instructions."}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-6">
        <a data-testid={`photographer-directions-${job.id}`} href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${job.address?.street || ""}, ${job.address?.city || ""}, ${job.address?.state || ""}`)}`} target="_blank" rel="noreferrer" className="inline-flex items-center px-3 py-2 border border-[#E5B869] text-[#E5B869] text-xs uppercase font-mono"><Navigation size={14} className="mr-2" />Directions</a>
        {job.status === "scheduled" && <Button data-testid={`photographer-in-transit-${job.id}`} onClick={() => onUpdateStatus(job.id, "in_transit")} className="rounded-none bg-[#E5B869] text-[#0B0C0E] hover:bg-[#D4A34F]">In transit</Button>}
        {job.status === "in_transit" && <Button data-testid={`photographer-on-site-${job.id}`} onClick={() => onUpdateStatus(job.id, "on_site")} className="rounded-none bg-[#E5B869] text-[#0B0C0E] hover:bg-[#D4A34F]">On site</Button>}
        {job.status === "on_site" && <Button data-testid={`photographer-complete-${job.id}`} onClick={() => onUpdateStatus(job.id, "completed")} className="rounded-none bg-[#E5B869] text-[#0B0C0E] hover:bg-[#D4A34F]">Mark complete</Button>}
      </div>
    </article>
  );
}

/** Empty state shown when the photographer has no assigned appointments. */
export function PhotographerJobsEmpty() {
  return (
    <div data-testid="photographer-portal-empty" className="py-16 text-center border border-dashed border-[#282C34] text-[#9A9EA7]">
      <MapPin size={22} className="mx-auto mb-3" />No assigned appointments yet.
    </div>
  );
}
